// eslint-disable-next-line unicorn/prevent-abbreviations
export default class DevQrCodeGeneratorController {
	constructor() {
		this.data = 'My QR code is here!';
		this.options = {
			color: {
				dark: '#000000ff',
				light: '#ffffffff',
			},
			errorCorrectLevel: 'M',
			margin:            4,
			scale:             4,
			small:             false,
			width:             undefined,
		};
	}
}
